<template>
  <div>
    <Headline
      :title="title"
      subtitle="Simple. Rápida. Ecológica"
      third-text="Geotur le ayuda a dar el primer paso en la creación del proceso de factura electrónica via EDI"
      image="billing"
    ></Headline>
    <Section image="billing-1">
      <Card
        title="La sustitucion del papel en un contexto empresarial es inevitable"
        size="lg"
        variant="list"
      >
        <p>La automatización y racionalización de este proceso administrativo permite, a corto plazo, reducir los costes operativos y generales.</p>
        <ul>
          <li>Reducción de los costes de tramitación y archivo de documentos</li>
          <li>Mayor control, rapidez y transparencia de los ciclos de facturación y pago</li>
          <li>Simplificación, automatización e integración de procesos</li>
          <li>Eliminación de errores y tareas administrativas</li>
          <li>Archivo legal y completo de facturas (acceso 24/7 a través de portal web)</li>
        </ul>
      </Card>
    </Section>
  </div>
</template>
<script setup>
definePageMeta({
  title: 'Facturación Electrónica',
  path: '/productos/facturacion-electronica',
})

const route = useRoute()
const title = route.meta.title
useHead({
  title: `${route.meta.title} | Geotur`,
})
</script>